<template>
    <div class="component-myDialog">
        <el-dialog v-model="dialogVisible" title="专属ISC.AI2026海报分享" width="50%" draggable :close-on-click-modal="false">
            <div class="poster-box" @click="dialogInjectionKey()">
                <PosterGenerator
                    ref="posterGeneratorVue"
                    v-if="data.title"
                    bgImage="https://s0.ssl.qhres2.com/static/51a8f3922cd14680.svg"
                    title="我刚刚向 ISC.AI 2026 提交了议题："
                    :subtitle="data.title"
                    :descList="desc"
                    :avatar="data.avatar"
                    :nickname="data.name"
                    qrCode="https://p0.ssl.qhimg.com/t110b9a93010fea8cfd79bde8e9.png"
                />
                <img class="poster-btn"
                    @click="downloadImg()"
                    src="https://p2.ssl.qhimg.com/t110b9a93015265cb59ceeae820.png"
                    alt=""
                />
            </div>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import PosterGenerator from './posterGenerator.vue'

const props = defineProps({
    data: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

// const showPoster = ref(false)
const desc = [
  '期待与你，一起加入这场定义未来的对话。',
  '',
  '扫码提交议题',
  '生成你的专属思想海报，100%有奖！'
]
let dialogVisible = ref(false)
let posterGeneratorVue = ref(null)

const openModel = () => {
    dialogVisible.value = true
}

const closeModel = () => {
    dialogVisible.value = false
}

const downloadImg = () => {
  const arr = posterGeneratorVue.value.posterUrl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  const blob = new Blob([u8arr], { type: mime })

  // IE兼容
  if (window.navigator.msSaveBlob) {
    window.navigator.msSaveBlob(blob, '专属分享海报.png')
  } else {
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = '专属分享海报.png'
    link.click()
  }
}

defineExpose({ // 导出方法
    openModel,
    closeModel
});

</script>

<style lang="scss" scoped>
.component-myDialog{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-carousel__item:nth-child(2n) {
        background-color: #fff;
        border-radius: 16px;  
        border: 1px solid #f2f3f5;
    }

    .el-carousel__item:nth-child(2n + 1) {
        background-color: #fff;
        border-radius: 16px;
        border: 1px solid #f2f3f5;
    }
    .el-carousel__item--card {
        opacity: 0.2;
    }
    .el-carousel__item--card.is-active {
        opacity: 1;
    }
    :deep(.el-carousel__arrow) {
        background-color: #595959;
    }
    :deep(.el-icon) {
        font-size: 16px;
    }
    .poster-box{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        padding: 20px 0;
        .el-carousel--horizontal{
            width: 800px;
            height: 710px;
        }
        .poster-img{
            width: 100%;
            border-radius: 16px; 
            box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.25);
            z-index: 10;
        }
    }
    .poster-btn{
        margin-top: 30px;
        margin-bottom: 10px;
        width: 220px;
        cursor: pointer;
    }
}
</style>